import { createWsConnectionSlice } from '@skynet/data-ws-core';
import { mmActions } from './actions';

const wsMmSlice = createWsConnectionSlice('wsMm', mmActions);

export type WsMmState = ReturnType<typeof wsMmSlice.getInitialState>;

export const wsMmActions = wsMmSlice.actions;

export default wsMmSlice.reducer;
